import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table, Spinner, Alert, Badge, ListGroup, Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import { FaMoneyBillAlt, FaBoxOpen, FaShippingFast, FaUser, FaCheckCircle } from 'react-icons/fa';
import apinode from '../../services/apinode.js'
import { useParams, useLocation } from 'react-router-dom';
import './OrderMercadoLibre.css'

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};


const OrderMercadoLibre = () => {

    const query = useQuery();
    const pack = query.get('pack'); // Obtenha o valor do parâmetro pack
    const seller = query.get('seller'); // Obtenha o valor do parâmetro pack


    // const { pack } = useParams();
    const [order, setOrder] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedItemId, setSelectedItemId] = useState(null); // State to track selected item
    const [itemOrder, setItemOrder] = useState(null); // State to hold item-specific order details
    const [showModal, setShowModal] = useState(false); // State to control modal visibility

    const API_ENDPOINT = `https://api.mercadolibre.com/orders`; // Base endpoint
    const API_PRODUTO = `https://api.mercadolibre.com/items`; // Base endpoint
    const token = `APP_USR-3348978167659605-101407-05002214f05b36fc928aa1b3bf66ee79-514066249`;

    const fetchOrderDetails = async (orderId) => {
        try {
            const response = await apinode.get(`exportml/orders/${localStorage.idconta}`, {
                params: {
                    seller: seller,
                    pack: orderId
                }
            });
            setOrder(response.data);
        } catch (error) {
            setError('Erro ao carregar os detalhes do pedido.');
        } finally {
            setIsLoading(false);
        }
    };


    console.log(pack)

    useEffect(() => {


        fetchOrderDetails(pack);

    }, []); // O useEffect roda sempre que o orderId mudar

    const handleItemClick = async (itemSKU) => {

        setIsLoading(true);
        setError(null);
        setSelectedItemId(itemSKU); // Set the selected item ID

        const idConta = localStorage.getItem('idconta'); // Obtenha o idconta do localStorage
        if (!idConta) {
            setError('ID da conta não encontrado no localStorage.');
            setIsLoading(false);
            return;
        }

        try {
            const response = await apinode.get(`exportml/mlb/${idConta}`, {
                params: {
                    seller: seller, // Certifique-se de que 'seller' está definido
                    mlb: itemSKU
                }
            });
            setItemOrder(response.data);
            console.log(response.data);
            setShowModal(true); // Show the modal when item is clicked
        } catch (error) {
            console.error(error); // Adicione este log para facilitar a depuração
            setError('Erro ao carregar os detalhes do item.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false); // Close the modal
        setItemOrder(null); // Reset item order state
        setSelectedItemId(null); // Reset selected item ID
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" style={{ color: '#FFE600' }} />
            </div>
        );
    }

    if (error) {
        return <Alert variant="danger">{error}</Alert>;
    }

    if (!order) {
        return <Alert variant="warning">Nenhum detalhe do pedido encontrado.</Alert>;
    }

    const {
        id,
        date_created,
        total_amount,
        buyer,
        order_items,
        status,
        payments
    } = order;

    return (
        <Container className="mt-4">
            <Card className="mb-4 shadow-sm border-0" style={{ borderRadius: '10px', backgroundColor: '#EBEBEB' }}>
                <Card.Header className="text-white" style={{ backgroundColor: '#3483FA', borderRadius: '10px 10px 0 0' }}>
                    <h3 className="mb-0"><FaBoxOpen /> Pedido #{id}</h3>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={8}>
                            <Card className="mb-4 border-0" style={{ backgroundColor: '#FFFFFF', borderRadius: '10px' }}>
                                <Card.Header className="bg-light">
                                    <h5><FaCheckCircle style={{ color: '#3483FA' }} /> Informações do Pedido</h5>
                                </Card.Header>
                                <Card.Body>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item><strong>Status:</strong> {status}</ListGroup.Item>
                                        <ListGroup.Item><strong>Data de Criação:</strong> {new Date(date_created).toLocaleString()}</ListGroup.Item>
                                        <ListGroup.Item><strong>Total:</strong> R$ {total_amount.toFixed(2)}</ListGroup.Item>
                                    </ListGroup>
                                </Card.Body>
                            </Card>

                            <Card className="mb-4 border-0" style={{ backgroundColor: '#FFFFFF', borderRadius: '10px' }}>
                                <Card.Header className="bg-light">
                                    <h5><FaShippingFast style={{ color: '#3483FA' }} /> Itens do Pedido</h5>
                                </Card.Header>
                                <Card.Body>
                                    <Table responsive hover className="mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>SKU</th>
                                                <th>Produto</th>
                                                <th>Quantidade</th>
                                                <th>Preço Unitário</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {order_items.map((item, index) => (
                                                <tr key={index} onClick={() => handleItemClick(item.item.id)} style={{ cursor: 'pointer' }}>
                                                    <td>{item.item.seller_sku}</td>
                                                    <td>{item.item.title}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>R$ {item.unit_price?.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Card className="mb-4 border-0" style={{ backgroundColor: '#FFFFFF', borderRadius: '10px' }}>
                                <Card.Header className="bg-light">
                                    <h5><FaMoneyBillAlt style={{ color: '#3483FA' }} /> Pagamento</h5>
                                </Card.Header>
                                <Card.Body>
                                    {payments.map((payment, index) => (
                                        <ListGroup key={index} variant="flush">
                                            <ListGroup.Item><strong>Método de Pagamento:</strong> {payment.payment_method_id}</ListGroup.Item>
                                            <ListGroup.Item><strong>Valor Pago:</strong> R$ {payment.transaction_amount?.toFixed(2)}</ListGroup.Item>
                                            <ListGroup.Item>
                                                <strong>Status do Pagamento:</strong>
                                                <Badge className="badge-gray">{payment.status}</Badge>
                                            </ListGroup.Item>



                                        </ListGroup>
                                    ))}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4}>
                            <Card className="mb-4 border-0" style={{ backgroundColor: '#FFFFFF', borderRadius: '10px' }}>
                                <Card.Header className="bg-light">
                                    <h5><FaUser style={{ color: '#3483FA' }} /> Informações do Comprador</h5>
                                </Card.Header>
                                <Card.Body>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item><strong>Nome:</strong> {buyer.first_name} {buyer.last_name}</ListGroup.Item>
                                        <ListGroup.Item><strong>Apelido:</strong> {buyer.nickname}</ListGroup.Item>
                                    </ListGroup>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Modal for item details */}
            <Modal show={showModal} onHide={handleCloseModal} dialogClassName="custom-modalzpl">
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes do Item Selecionado</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {itemOrder ? (
                        <>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {/* Exibindo a thumbnail do item */}
                                <img
                                    src={itemOrder.thumbnail}
                                    alt={itemOrder.title}
                                    style={{ width: '100px', height: 'auto', marginRight: '15px' }} // Ajustes de estilo
                                />
                                <ListGroup variant="flush" style={{ flexGrow: 1 }}>
                                    <ListGroup.Item>
                                        <strong>SKU:</strong> {itemOrder.seller_sku || 'Não disponível'}
                                        <strong> | ID:</strong> {selectedItemId || 'Não disponível'}
                                    </ListGroup.Item>

                                    <ListGroup.Item>
                                        <strong>Nome do Produto:</strong> {itemOrder.title || 'Não disponível'}
                                    </ListGroup.Item>

                                    <ListGroup.Item>
                                        <strong>Preço:</strong> R$ {itemOrder.price?.toFixed(2) || 'Não disponível'}
                                    </ListGroup.Item>

                                    <ListGroup.Item>
                                        <strong>Status do Item:</strong>
                                        <Badge bg={itemOrder.status === 'Aprovado' ? 'success' : 'danger'}>
                                            {itemOrder.status || 'Não disponível'}
                                        </Badge>
                                    </ListGroup.Item>

                                    {/* Informações adicionais do item */}
                                    <ListGroup.Item>
                                        <strong>Quantidade:</strong> {itemOrder.quantity || 'Não disponível'}
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong>Data de Compra:</strong> {itemOrder.purchase_date || 'Não disponível'}
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong>Descrição:</strong> {itemOrder.description || 'Não disponível'}
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>
                        </>
                    ) : (
                        <Spinner animation="border" style={{ color: '#FFE600' }} />
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default OrderMercadoLibre;
